export const getWordCount = (...values: (string | undefined | null)[]) => {
  const wordCount = values.reduce(
    (prev, value) =>
      prev +
      (value
        ? value
            .trim()
            .split(/[\n\r\s]+/)
            .filter((v) => !!v).length
        : 0),
    0,
  );
  const characterCount = values.reduce(
    (prev, value) => prev + (value ? value.length : 0),
    0,
  );

  return `${wordCount} mots - ${characterCount} caractères`;
};
